import { mockDataUtil } from './mockDataUtil';
import { itemStoreRelationshipList } from '../mock/itemStoreRelationshipData';
import { API_ENDPOINTS } from '../utils/apiEndpoints';
import httpClient from './httpClient';
import {
  ItemStoreRelationship,
  ItemStoreRelationshipFilters,
  ItemStoreRelationshipPaginationParams,
  ApiResponse,
  ItemStoreRelationshipPaginatedResponse
} from '../types/item-store-relationship';
import { WHOLE_USE_MOCK } from './api';

class ItemStoreRelationshipService {
  
  async getMock(): Promise<boolean> {
    return true;
  }

  /**
   * 获取门店货品关系分页列表
   * @param filters 筛选条件
   * @param pagination 分页参数
   * @returns 分页门店货品关系列表
   */
  async getItemStoreRelationships(
    filters: ItemStoreRelationshipFilters,
    pagination: ItemStoreRelationshipPaginationParams
  ): Promise<ApiResponse<ItemStoreRelationshipPaginatedResponse<ItemStoreRelationship>>> {
    if (await this.getMock() && WHOLE_USE_MOCK) {
      let filteredData = [...itemStoreRelationshipList];

      // 应用筛选条件
      if (filters.storeCode) {
        filteredData = filteredData.filter(item => item.storeCode === filters.storeCode);
      }

      if (filters.itemCode) {
        filteredData = filteredData.filter(item => item.itemCode === filters.itemCode);
      }

      if (filters.status) {
        filteredData = filteredData.filter(item => item.status === filters.status);
      }

      if (filters.ownerCode) {
        filteredData = filteredData.filter(item => item.ownerCode === filters.ownerCode);
      }

      if (filters.search) {
        const searchLower = filters.search.toLowerCase();
        filteredData = filteredData.filter(item =>
          item.storeCode.toLowerCase().includes(searchLower) ||
          item.itemCode.toLowerCase().includes(searchLower) ||
          (item.storeName && item.storeName.toLowerCase().includes(searchLower)) ||
          (item.itemName && item.itemName.toLowerCase().includes(searchLower)) ||
          item.ownerCode.toLowerCase().includes(searchLower)
        );
      }

      // 排序
      if (pagination.sortBy && pagination.sortOrder) {
        filteredData.sort((a, b) => {
          const aValue = a[pagination.sortBy!];
          const bValue = b[pagination.sortBy!];
          
          // 处理数字类型
          if (typeof aValue === 'number' && typeof bValue === 'number') {
            return pagination.sortOrder === 'asc' ? aValue - bValue : bValue - aValue;
          }
          
          // 处理字符串类型
          const aStr = String(aValue || '');
          const bStr = String(bValue || '');
          
          if (pagination.sortOrder === 'asc') {
            return aStr.localeCompare(bStr);
          } else {
            return bStr.localeCompare(aStr);
          }
        });
      }

      const response = await mockDataUtil.mockPageRes(filteredData, {
        currentPage: pagination.currentPage,
        totalCount: filteredData.length,
        pageSize: pagination.pageSize
      });
      return response as unknown as ApiResponse<ItemStoreRelationshipPaginatedResponse<ItemStoreRelationship>>;
    } else {
      const requestData = {
        ...filters,
        ...pagination,
        sortOrder: pagination.sortOrder === 'asc' ? 'asc' : 'desc'
      };
      
      const res = await httpClient.post(API_ENDPOINTS.ITEM_STORE_RELATIONSHIP.PAGE, requestData);
      return res.data;
    }
  }

  /**
   * 批量更新货品门店关系的displayType
   * @param idList 要更新的记录ID列表
   * @param displayType 新的displayType值
   * @returns 更新结果
   */
  async batchUpdateDisplayType(
    idList: number[],
    displayType: string
  ): Promise<ApiResponse<boolean>> {
    if (await this.getMock() && WHOLE_USE_MOCK) {
      // 模拟API调用延迟
      await new Promise(resolve => setTimeout(resolve, 500));
      
      // 在实际项目中，这里会更新mock数据
      // 但在当前实现中，我们只是模拟成功的响应
      return {
        traceId: 'mock-trace-id',
        success: true,
        flag: 'success',
        data: true
      } as ApiResponse<boolean>;
    } else {
      // 实际API调用
      const res = await httpClient.post(API_ENDPOINTS.ITEM_STORE_RELATIONSHIP.BATCH_UPDATE_DISPLAY_TYPE, {
        idList,
        displayType
      });
      return res.data;
    }
  }
}

export const itemStoreRelationshipService = new ItemStoreRelationshipService();